<template>
  <div style="margin-top: 10px">
    <div class="row justify-content-md-center">
      <div class="col-lg-6 col-md-8 col-sm-12 no-padding">
        <div class="card">
          <h3 v-if="pageconfig[0] != undefined" class="card-header text-white bg-dark">{{ pageconfig[0].title }}</h3>
          <div class="card-body">
            <div class='slot-machine'>
              <div class='slot text-center' v-for='slot in pageconfig' ref='pageconfig'>
                <div class='slot__window'>
                  <div class='slot__wrap'>
                    <div class='slot__item' v-for='opt in slot.items'><p class="slot__text">{{ opt }}</p></div>
                    <div class='slot__item slot__item--copy'><p class="slot__text">{{ slot.items[0] }}</p></div>
                  </div>
                </div>
                <div style="margin-top: 10px">
                  <button @click='start' type="button" class="btn btn-dark btn-lg btn-block">A jugar!!!</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  const next = window.requestAnimationFrame ||
    window.webkitRequestAnimationFrame ||
    window.mozRequestAnimationFrame ||
    window.msRequestAnimationFrame ||
    window.oRequestAnimationFrame ||
    function(cb) { window.setTimeout(cb, 1000/60) };

  export default {
    name: "app-teetotums",
    props: {
      pageconfig: { type: Array, requite: true }
    },
    data: function(){
      return {
        opts: null,
        startedAt: null
      }
    },
    methods: {
      start: function () {
        if (this.opts) {
          return
        }

        this.opts = this.pageconfig.map((data, i) => {

          const slot = this.$refs.pageconfig[i];
          const choice = Math.floor(Math.random() * data.items.length);

          const opts = {
            el: slot.querySelector('.slot__wrap'),
            finalPos: choice * 180,
            startOffset: 2000 + Math.random() * 500 + i * 500,
            height: data.items.length * 180,
            duration: 3000 + i * 700, // milliseconds
            isFinished: false,
          };
          return opts
        });

        next(this.animate)

      },

      animate: function (timestamp) {
        if (this.startedAt == null) {
          this.startedAt = timestamp
        }

        const timeDiff = timestamp - this.startedAt;

        this.opts.forEach(opt => {
          if (opt.isFinished) {
            return
          }

          const timeRemaining = Math.max(opt.duration - timeDiff, 0);
          const power = 3;
          const offset = (Math.pow(timeRemaining, power) / Math.pow(opt.duration, power)) * opt.startOffset;

          // negative, such that pageconfig move from top to bottom
          const pos = -1 * Math.floor((offset + opt.finalPos) % opt.height);
          opt.el.style.transform = "translateY(" + pos + "px)";

          if (timeDiff > opt.duration) {
            opt.isFinished = true
          }
        });

        if (this.opts.every(o => o.isFinished)) {
          this.opts = null;
          this.startedAt = null;
        } else {
          next(this.animate)
        }
      }
    }
  }
</script>

<style scoped>
  .slot {
    float: left;
    width: 100%;
  }

  .slot__window {
    background-color: white;
    width: 100%;
    height: 180px;
    overflow: hidden;
  }

  .slot__wrap {

  }

  .slot__text {
    font-size: 32px;
    color: #343a40;
  }

  .slot__item {
    margin-top: 00px;
    height: 180px;
    width: 100%;
    padding: 0 10px;

    text-align: center;
    background-color: white;
    color: black;

    line-height: 160px;
  }

  .slot__item--copy {
  }
</style>



// WEBPACK FOOTER //
// src/components/app-teetotums.vue